import React from 'react';

interface Props {
	hide?: boolean;
}
export const FilterGroup = (props: React.PropsWithChildren<Props>) => {
	return !props.hide ? (
		<>
			{props.children}
		</>
	) : null;
};

FilterGroup.defaultProps = {
	hide: false,
};